export {
  useSendCommunicationApi,
  resetSendCommunicationApi,
} from './useSendCommunicationApi';
export { reducerSendCommunicationApi } from './reducerSendCommunicationApi';
